import _ from 'lodash';
import { mixed, number, object } from 'yup';

const CREDIT_AMOUNT_MIN = 0.01;

export const creditFormSchema = object().shape({
  creditSource: mixed()
    .nullable()
    .test('creditSource-required', 'Credit source is required', value => {
      if (_.isNil(value) || (_.isObject(value) && _.isNil(value.value))) {
        return false;
      }

      return true;
    }),
  amount: number()
    .typeError('Credit amount must be a number')
    .min(CREDIT_AMOUNT_MIN, 'Credit amount must be greater than 0')
    .required('Credit amount must be greater than 0'),
});
